import React, { useEffect, useState } from "react";
// import AboutArea from "../components/About/AboutArea";
// import CompanyAbout from "../components/About/CompanyAbout";
// import HistoryArea from "../components/About/HistoryArea";
// import Team from "../components/About/Team";
//import AboutArea from "../components/HomeTwo/AboutArea";

import Breadcrumb from "../components/common/Breadcrumb";
import Footer from "../components/common/Footer";
import Header from "../components/common/Header";
import SEO from "../components/seo";
import EagleVision from "./eagle-vision";
import { useLanguage } from "../contexts/LanguageContext";

const translationKeys = {
  ABOUT_PAGE_TITLE: "About",
  BREADCRUMB_TITLE: "About us",
  BREADCRUMB_SUBTITLE: "About Company",
  HOME: "Home",
};

const About = () => {
  const { currentLanguage, translateContent } = useLanguage();
  const [translations, setTranslations] = useState(translationKeys);

  useEffect(() => {
    const translateAll = async () => {
      const keys = Object.keys(translationKeys);
      const newTranslations = {};
      const translationPromises = keys.map(async (key) => {
        try {
          const translated = await translateContent(translationKeys[key]);
          newTranslations[key] = translated || translationKeys[key];
        } catch {
          newTranslations[key] = translationKeys[key];
        }
      });
      await Promise.all(translationPromises);
      setTranslations(newTranslations);
    };
    translateAll();
  }, [currentLanguage, translateContent]);

  return (
    <main>
      <SEO pageTitle={translations.ABOUT_PAGE_TITLE} />
      <Header />
      <Breadcrumb
        title={translations.BREADCRUMB_TITLE}
        subtitle={translations.BREADCRUMB_SUBTITLE}
        homeLabel={translations.HOME}
      />
      {/* <AboutArea/> */}
      <EagleVision />
      {/* <HistoryArea/>
      <Team/>
      <CompanyAbout/> */}
      <Footer />
    </main>
  );
};

export default About;